// cspell: ignore syncbird
import Bluebird from 'bluebird';
export const Syncbird = Bluebird.getNewLibraryCopy();
Syncbird.config({
    asyncHooks: false,
    cancellation: false,
    longStackTraces: false,
    monitoring: false,
    warnings: false,
});
// Bluebird uses `_then` internally.
const _then = Syncbird.prototype._then;
Syncbird.prototype._then = function (onfulfilled, onrejected, _, receiver, internalData) {
    if (this.isFulfilled()) {
        if (!onfulfilled) {
            return this;
        }
        else {
            // Synchronously call `onfulfilled`, and wrap the result in a new `Syncbird` object.
            return Syncbird.resolve(onfulfilled.call(receiver, this.value()));
        }
    }
    else {
        // Forward to Bluebird's `_then` method.
        return _then.call(this, onfulfilled, onrejected, _, receiver, internalData);
    }
};
Syncbird.prototype.valueOrPromise = function () {
    if (this.isFulfilled()) {
        return this.value();
    }
    else {
        return this;
    }
};
//# sourceMappingURL=syncbird.js.map